import React from 'react'
import PropTypes from 'prop-types'
import { InView } from 'react-intersection-observer'
import MobileSearchbarContent from './mobile/MobileSearchbarContent'

const MobilePublicSearchBar = ({ selectedDestination, setSelectedDestination }) => {
  return <InView>
    {({ ref }) => {
      return (
        <div ref={ref}>
          <MobileSearchbarContent
            isHomepage={false}
            selectedDestination={selectedDestination}
            setSelectedDestination={setSelectedDestination}
          />
        </div>
      )
    }}
  </InView >
}

MobilePublicSearchBar.propTypes = {
  selectedDestination: PropTypes.object,
  setSelectedDestination: PropTypes.func,
}

export default MobilePublicSearchBar
